import { Fragment, memo } from 'react';

import { JoyajoyImage, JoyajoyImageFile } from '../JoyajoyImage';
import './List.css';

export type ListProps = {
  data: ListItemProps[];
};

export const List = memo(({ data }: ListProps) => {
  return (
    <div className="selectable-list">
      {data.map((item, index) => (
        <Fragment key={index}>
          {index != 0 && <hr className="page-hr" />}
          <ListItem key={index} {...item} />
        </Fragment>
      ))}
    </div>
  );
});

export const SettingList = memo(({ data }: ListProps) => {
  return (
    <div className="selectable-list">
      {data.map((item, index) => (
        <Fragment key={index}>
          {index != 0 && <hr className="page-hr" />}
          <SettingListItem key={index} {...item} />
        </Fragment>
      ))}
    </div>
  );
});

export type ListItemProps = {
  icon?: JoyajoyImageFile; // Made optional by adding '?'
  title: string;
  description: string;
  rightComponent?: React.ReactElement;
  rightIcon?: string;
  onPress: () => void;
};

const ListItem = memo(
  ({
    icon,
    title,
    description,
    rightComponent,
    rightIcon,
    onPress,
  }: ListItemProps) => {
    return (
      <div className="list-item" onClick={onPress}>
        {icon && <JoyajoyImage {...icon} className={'icon'} />}
        <div className="text">
          <div className="title">{title}</div>
          <div className="description">{description}</div>
        </div>
        {rightComponent}
        {rightIcon && <img src={rightIcon} className="right-icon" />}
      </div>
    );
  },
);

const SettingListItem = memo(
  ({ icon, title, description, rightComponent, onPress }: ListItemProps) => {
    return (
      <div className="list-item" onClick={onPress}>
        {icon && <JoyajoyImage {...icon} className={'icon'} />}
        <div className="text-left">
          <div className="title">{title}</div>
        </div>
        <div className="description-right">
          {description}
          {rightComponent}
        </div>
      </div>
    );
  },
);
